export const GA_TRACKING_ID = 'G-BZZK42FL2E';

/**
 * Define o ID do usuário (geralmente após o login) para rastreamento cross-device.
 */
export const setUserId = (userId: string) => {
  if (typeof window !== 'undefined' && typeof window.gtag === 'function') {
    window.gtag('config', GA_TRACKING_ID, {
      user_id: userId
    });
  }
};

/**
 * Dispara um evento customizado ou padrão do GA4.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const trackEvent = (eventName: string, params?: Record<string, any>) => {
  if (typeof window !== 'undefined' && typeof window.gtag === 'function') {
    window.gtag('event', eventName, params);
  }
};

/**
 * Helpers específicos para e-commerce e conversões
 */
export const trackLogin = (method: string, role?: string) => {
  trackEvent('login', { method, role });
};

export const trackGenerateLead = (source?: string) => {
  trackEvent('generate_lead', { source });
};

export const trackWhatsAppClick = (url: string, origin: string) => {
  trackEvent('click_whatsapp', { url, origin });
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const trackBeginCheckout = (items: any[], value: number, currency: string = 'BRL') => {
  trackEvent('begin_checkout', { items, value, currency });
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const trackPurchase = (transactionId: string, items: any[], value: number, currency: string = 'BRL', paymentMethod?: string) => {
  trackEvent('purchase', {
    transaction_id: transactionId,
    value,
    currency,
    items,
    payment_type: paymentMethod
  });
};
